import React from "react";

import { environment } from "@/environments/environment";
import { mode } from "@/utils/env";
import * as Sentry from "@sentry/react";
import {
  Routes,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from "react-router-dom";

Sentry.init({
  dsn: environment.sentryDsn,
  environment: mode,
  release: environment.appVersion,
  integrations: [
    Sentry.breadcrumbsIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.browserTracingIntegration()
  ],
  // Drop noise from the third-party CookieFirst consent banner. Its script
  // (served from our domain) throws unhandled rejections such as
  // "[CF] Failed to load configs, check API key" when its CDN is slow,
  // rate-limited or blocked — nothing we can act on, but it was our top issue
  // by affected users. Filter by both message prefix and originating script.
  ignoreErrors: [/^\[CF\]/],
  denyUrls: [/consentBanner(\.no-autoblock)?\.js/i, /consent\.cookiefirst\.com/i],
  tracesSampleRate: mode === "production" ? 0.2 : 1.0
});

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
export { captureError } from "./captureError";
